import Home from "./pages/Home";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import Loader from "./components/Loader";
import { useDispatch } from "react-redux";
import { Route, Routes } from "react-router";
import PrivateRoute from "./layout/PrivateRoute";
import PageNotFound from "./layout/PageNotFound";
import ForgotPassword from "./pages/ForgotPassword";
import TermsAndConditions from "./pages/policies/TermsAndConditions";
import PrivacyPolicy from "./pages/policies/PrivacyPolicy";
import AcceptableUsePolicy from "./pages/policies/AcceptableUsePolicy";
import { Suspense, useEffect, useState } from "react";
import { saveFcmToken } from "./redux/reducers/authReducer";
import { AllRoutes, pageRoutes } from "./routes/PageRoutes";
import { onMessageListener, requestForToken } from "./auth/Firebase";
import "./App.css";

function App() {
  // const [fcmToken, setFcmToken] = useState(null);
  // const dispatch = useDispatch();
  // const [notification, setNotification] = useState(null);

  // useEffect(() => {
  //   // Register service worker
  //   if ("serviceWorker" in navigator) {
  //     navigator?.serviceWorker?.register(`${process.env.PUBLIC_URL}/firebase-messaging-sw.js`)
  //       .then((registration) => {
  //         console.log(
  //           "Service Worker registered with scope:",
  //           registration?.scope
  //         );
  //       })
  //       .catch((error) => {
  //         console.error("Service Worker registration failed:", error);
  //       });
  //   }
  //   requestForToken(setFcmToken);
  //   if (fcmToken) dispatch(saveFcmToken(fcmToken));
  // }, []);

  // useEffect(() => {
  //   // Listen for foreground messages
  //   onMessageListener()
  //     .then((payload) => {
  //       setNotification(payload);
  //       console.log("Received foreground message:", payload);
  //     })
  //     .catch((error) =>
  //       console.error("Error receiving foreground message: ", error)
  //     );
  // }, []);

  return (
    <div>
      <Suspense fallback={<Loader />}>
        <Routes>
          {AllRoutes?.map((item) => {
            return (
              <Route
                path={item.path}
                exact
                element={<PrivateRoute>{item?.element}</PrivateRoute>}
              />
            );
          })}
          <Route path={pageRoutes.landingpage} exact element={<Home />} />
          <Route path={pageRoutes.login} exact element={<Login />} />
          <Route path={pageRoutes.signup} exact element={<SignUp />} />
          <Route
            path={pageRoutes.forgot_password}
            exact
            element={<ForgotPassword />}
          />
          <Route
            path={pageRoutes.terms_and_conditions}
            exact
            element={<TermsAndConditions />}
          />
          <Route
            path={pageRoutes.privacy_policy}
            exact
            element={<PrivacyPolicy />}
          />
          <Route
            path={pageRoutes.acceptable_use_policy}
            exact
            element={<AcceptableUsePolicy />}
          />
          <Route
            path={pageRoutes.page_not_found}
            exact
            element={<PageNotFound />}
          />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
